import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const AgentCodeName = (props) => {
  return (
    <FormGroup controlId="agentCodeName">
       <Col componentClass={ControlLabel} sm={2}>
          Agent Code {props.required ? '*' : ''}
       </Col>
       <Col sm={5}>
           <FormControl
              type="text"
              required={props.required}
              onBlur={props.handleGetAgentName}
              disabled={props.systemRole === 'agent'}
              onChange={props.handleChangeAgentCode}
              value={props.agentCode}
              maxLength="8"
              autoComplete="off"
            />

      </Col>
     <Col sm={5}>
         <FormControl
            type="text"
            disabled={props.systemRole === 'agent'}
            required={props.required}
            data-readOnly={props.required}
            value={props.agentName}
            autoComplete="off"
         />
     </Col>
    </FormGroup>
  )
}

AgentCodeName.propTypes = {
  agentCode: PropTypes.string,
  agentName: PropTypes.string,
  handleGetAgentName: PropTypes.func,
  handleChangeAgentCode: PropTypes.func,
  systemRole: PropTypes.string,
  required: PropTypes.bool
};

export default AgentCodeName;



// WEBPACK FOOTER //
// ./src/app/components/agentCodeName/AgentCodeName.js